"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAppSelector = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledAppSelector = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-right: 1px solid ", ";\n\n  > div {\n    > button {\n      padding: 0;\n      background-color: ", ";\n      width: 32px;\n      height: 32px;\n      ", ";\n\n      &:hover {\n        background-color: ", ";\n      }\n\n      &:focus {\n        box-shadow: 0 0 0 2px ", ";\n      }\n\n      i {\n        ", ";\n        color: ", ";\n        font-size: ", ";\n      }\n    }\n\n    > div {\n      z-index: 1;\n      padding: ", ";\n    }\n\n    li {\n      display: flex;\n\n      button {\n        height: 40px;\n        padding: ", ";\n\n        img {\n          padding: 0;\n        }\n\n        span {\n          font-size: ", ";\n          font-family: ", ";\n        }\n\n        &:hover {\n          background: ", ";\n        }\n\n        &:focus {\n          outline: none;\n        }\n      }\n    }\n  }\n"], ["\n  border-right: 1px solid ", ";\n\n  > div {\n    > button {\n      padding: 0;\n      background-color: ", ";\n      width: 32px;\n      height: 32px;\n      ", ";\n\n      &:hover {\n        background-color: ", ";\n      }\n\n      &:focus {\n        box-shadow: 0 0 0 2px ", ";\n      }\n\n      i {\n        ", ";\n        color: ", ";\n        font-size: ", ";\n      }\n    }\n\n    > div {\n      z-index: 1;\n      padding: ", ";\n    }\n\n    li {\n      display: flex;\n\n      button {\n        height: 40px;\n        padding: ", ";\n\n        img {\n          padding: 0;\n        }\n\n        span {\n          font-size: ", ";\n          font-family: ", ";\n        }\n\n        &:hover {\n          background: ", ";\n        }\n\n        &:focus {\n          outline: none;\n        }\n      }\n    }\n  }\n"])), function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Backgrounds.subtle;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.white;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('both');
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Backgrounds.subtle;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.primary;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('both');
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Brand.normal;
}, function (_a) {
    var Iconology = _a.theme.Iconology;
    return Iconology.Sizes.sm;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x1;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x1;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.smd;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.fontFamily;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Brand.disabled;
});
var templateObject_1;
